import React from "react";
import styled from "@emotion/styled";
import DefaultOrangeButton from "@modules/Components/DefaultOrangeButton";
import { useDispatch } from "react-redux";
import { defaultAction } from "../actions/defaultAction";
import { SHOW_SIGN_IN_POPUP_MODAL } from "../constants/actionTypes";

const EmptyHeader = styled.h1`
  font-size: 24px;
  font-weight: bold;
  line-height: 1.5;
  color: #1f2021;
  margin-top: 44px;
  margin-bottom: 22px;

  @media (max-width: 400px) {
    font-size: 23px;
  }
`;

const EmptyP = styled.div`
  font-size: 16px;
  line-height: 1.88;
  color: #777984;
  margin-bottom: 38px;

  @media (max-width: 400px) {
    font-size: 15px;
  }
`;

const EmptyImageContainer = styled.div`
  height: auto;
  width: 189px;
  margin: 0 auto;
  min-height: 125px;
`;

const EmptyImage = styled.img`
  width: 100%;
  height: auto;
`;

const LoginRequired = () => {
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(defaultAction(SHOW_SIGN_IN_POPUP_MODAL, "account"));
  };
  return (
    <>
      <EmptyImageContainer>
        <EmptyImage
          src="https://cdn.cardcash.com/website/ui/elements/empty_cart.png"
          alt="bird empty cup"
        />
      </EmptyImageContainer>
      <EmptyHeader>You're just a login away from everything!</EmptyHeader>
      <EmptyP>Log in to access all your goodies.</EmptyP>
      <DefaultOrangeButton handleClick={handleClick}>
        Login to continue
      </DefaultOrangeButton>
    </>
  );
};

export default LoginRequired;
